module.exports = __webpack_public_path__ + "img/Puerto Rico.f801a30f.svg";